import React, { useEffect, useRef, useState } from "react";
import { api } from "@/api/client";

// Debounced server-driven typeahead (matches mobile SuggestInput).
export default function SuggestInput({
  value,
  onChange,
  endpoint,
  params = {},
  resultKey,
  placeholder,
  testID,
  className = "",
}) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [focused, setFocused] = useState(false);
  const timer = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!focused) return;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const qs = new URLSearchParams({ q: value || "", ...params });
        const r = await api(`${endpoint}?${qs.toString()}`);
        const list = r[resultKey] || [];
        setSuggestions(list);
        setOpen(list.length > 0);
      } catch {
        setSuggestions([]);
      }
    }, 250);
    return () => timer.current && clearTimeout(timer.current);
  }, [value, focused, JSON.stringify(params)]);

  useEffect(() => {
    const onClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const baseInput =
    "w-full rounded-lg border border-line bg-white px-3 py-2.5 text-[15px] text-ink outline-none focus:border-brand";

  return (
    <div className="relative" ref={boxRef}>
      <input
        data-testid={testID}
        value={value}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => {
          setFocused(true);
          if (suggestions.length) setOpen(true);
        }}
        className={`${baseInput} ${className}`}
        autoComplete="off"
      />
      {open && suggestions.length > 0 && (
        <div className="absolute left-0 right-0 top-full z-40 mt-1 max-h-56 overflow-y-auto rounded-lg border border-line bg-white shadow-lg">
          {suggestions.map((s, i) => (
            <button
              type="button"
              key={`${s}-${i}`}
              data-testid={`${testID}-option-${i}`}
              className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-brand-tint"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(s);
                setOpen(false);
              }}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
